<template>
  <swiper-content>
    <swiper-slide>
      <div class="slide-content">
        <div class="page-layout">
          <br>
          <img
            src="addons/apple-icon-row.png"
            class="header-image booth1-header1"
            style="max-width: 100%; margin-bottom:2vh;"
          />
          <h2 style="font-size: 1.5rem; line-height: 1.75rem">
            Enjoy our exclusive Singtel Apple Content Bundle with your new
            iPhone!
          </h2>
          <p style="text-align: left;">For $10/mth you get:<br/><br/>
            <ul>               
              <li>10GB of extra data with FREE 5G access</li>
              <li>12 FREE mths of Apple iCloud (50GB)</li>
              <li>9 FREE mths* of Apple Arcade</li>
            </ul>
          </p>
            <p>
              <b>Experience new ﬁrsts on SG’s fastest 5G network today!</b>
            </p>      
          <a
            target="_blank"
            href="https://www.singtel.com/personal/products-services/mobile/info/apple?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=bundle-hotspot&utm_campaign=iphone-2020-launch"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply.</p>
        </div>
      </div>
    </swiper-slide>
   
      <swiper-slide>
        <div class="slide-content">
          <div class="page-layout">
            <img
              src="addons/booth-3-header2.svg"
              class="header-image booth1-header1"
            />
            <h2>Market Trial</h2>
             <p >
                Experience Singapore’s fastest 5G speeds on your new iPhone when you purchase an extra 10GB of data at just $10/mth (U.P. $15/mth) on our Combo / XO plans. 
            </p>
           <a
           target="_blank" 
            href="https://www.singtel.com/personal/products-services/mobile/5g?utm_source=virtual-store&utm_medium=virtual-store&utm_term=apple&utm_content=bundle-hotspot&utm_campaign=iphone-2020-launch"
            class="st-button-red-outline page-button-bottom"
          >
            Find out more
          </a>
          <p class="small">T&amp;Cs apply. Market Trial ends Feb’21.</p>

          </div>
        </div>
      </swiper-slide>
 
  </swiper-content>
</template>

<script>
import "swiper/swiper-bundle.css";

export default {
  //https://github.com/surmon-china/vue-awesome-swiper
  name: "AddonsPage3",
};
</script>

<style scoped></style>
